import { useEffect, useState } from "react";

export const toDate = (d) => {
    if (!d) {
        return null;
    }
    return new Date(d);
};

export const toDateString = (d) => {
    d = toDate(d);
    if (!d) {
        return null;
    }
    return d.toLocaleDateString();
};

export const yyyymmdd = (d) => {
    d = toDate(d);
    if (!d) {
        return null;
    }
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    let _d = d.getDate();
    m = m.toString().padStart(2, "0");
    _d = _d.toString().padStart(2, "0");
    return `${y}-${m}-${_d}`;
};

export const yyyymmddCn = (d) => {
    d = toDate(d);
    if (!d) {
        return null;
    }
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    let _d = d.getDate();
    m = m.toString().padStart(2, "0");
    _d = _d.toString().padStart(2, "0");
    return `${y}年${m}月${_d}日`;
};

export const toDateTimeString = (d) => {
    d = toDate(d);
    if (!d) {
        return null;
    }
    return d.toLocaleString();
};

export const useNow = () => {
    const [now, setNow] = useState(new Date());
    useEffect(() => {
        let h = setInterval(() => {
            setNow(new Date());
        }, 1000);
        return () => {
            clearInterval(h);
        };
    }, []);
    return { now };
};

export const toDateWeekdayTimeString = (d) => {
    d = toDate(d);

    if (!d) {
        return null;
    }
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    let _d = d.getDate();
    let wd = d.getDay();
    wd %= 7;
    wd = { 1: "一", 2: "二", 3: "三", 4: "四", 5: "五", 6: "六", 0: "日" }[wd];
    let hh = d.getHours().toString().padStart(2, "0");
    let mm = d.getMinutes().toString().padStart(2, "0");
    let ss = d.getSeconds().toString().padStart(2, "0");
    return `${y}年${m}月${_d}日 星期${wd} ${hh}:${mm}:${ss}`;
};

export const toMonthString = (d) => {
    d = toDate(d);
    if (!d) {
        return d;
    }
    let p = [];
    let y = d.getFullYear();
    if (y != new Date().getFullYear()) {
        p.push(`${y}年`);
    }
    let m = d.getMonth() + 1;
    p.push(`${m}月`);
    p = p.join("");
    return p;
};

export const recent8Months = () => {
    let rets = [];
    for (let i = 0; i < 8; i++) {
        let d = new Date();
        d.setMonth(d.getMonth() - i);
        d = new Date(d);
        let m = toMonthString(d);
        rets.push(m);
    }
    rets.reverse();
    return rets;
};
